import { requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { AuthError } from '@juvare/platform-app/App';
import { implementTypedPlatformFunction } from '@juvare/platform-sdk-react/backend/features/typed-platform-functions';
import { accountBadgeEntityName } from '../entities/AccountBadgeEntityTypes';
import { badgeEntityName } from '../entities/BadgeEntityTypes';
import { getAccountBadgeFiltersByStatus } from '../utils/getAccountBadgeFiltersByStatus';
import { getBadgeDetailsFunctionDef } from './getBadgeDetailsSchema';
export const getBadgeDetailsFunctionImpl = implementTypedPlatformFunction(getBadgeDetailsFunctionDef, getBadgeDetails);
export function getBadgeDetails(context, req) {
    var _a;
    const badgeStorage = context.storage(badgeEntityName);
    const accountBadgeStorage = context.storage(accountBadgeEntityName);
    if (!requireAnySystemPermission(context.userState, 'manage-badges', 'manage-account-badges')) {
        throw new AuthError('Unauthorized');
    }
    const badge = badgeStorage.get(req.id);
    const countsForAllStatuses = {
        valid: accountBadgeStorage.count({ filter: getAccountBadgeFiltersByStatus(badge.id, 'valid') }),
        expired: accountBadgeStorage.count({ filter: getAccountBadgeFiltersByStatus(badge.id, 'expired') }),
        revoked: accountBadgeStorage.count({ filter: getAccountBadgeFiltersByStatus(badge.id, 'revoked') }),
        reissueNeeded: accountBadgeStorage.count({ filter: getAccountBadgeFiltersByStatus(badge.id, 'reissueNeeded') }),
    };
    const invalidAccountBadgesCount = Object.keys(countsForAllStatuses).reduce((sum, key) => (key === 'valid' ? sum : countsForAllStatuses[key] + sum), 0);
    const accountBadges = accountBadgeStorage
        .list({
        filter: [
            {
                op: '=',
                column: 'badgeId',
                value: badge.id,
            },
        ],
    })
        .rows.map((row) => ({ accountId: row.columns.accountId }));
    return {
        id: badge.id,
        name: badge.data.name,
        description: badge.data.description,
        expirationIntervalMonths: badge.data.expirationIntervalMonths,
        organizationIds: (_a = badge.data.organizationIds) !== null && _a !== void 0 ? _a : [],
        validAccountBadgesCount: countsForAllStatuses.valid,
        invalidAccountBadgesCount,
        expiredAccountBadgesCount: countsForAllStatuses.expired,
        reissueNeededAccountBadgesCount: countsForAllStatuses['reissueNeeded'],
        revokedAccountBadgesCount: countsForAllStatuses.revoked,
        accountBadges,
    };
}
